export default __webpack_public_path__ + "static/media/corner.f3357493.svg";